module.exports = __webpack_public_path__ + "school/img/practiceSeparateMedicineBg.26036aab.jpg";